export default __webpack_public_path__ + "static/media/YouMe_Stamp.b5fa12ef.png";